export default function LoginForm({ setEmail, setPassword, handleLogin, handleGoogleLogin, setIsActive }) {
    return (
        <div className="form-box login">
          <h2>Login</h2>
          <form onSubmit={handleLogin}>
            <div className="input-box">
              <span className="icon"><ion-icon name="mail"></ion-icon></span>
              <input type="email" required onChange={(e) => setEmail(e.target.value)} />
              <label>Email</label>
            </div>
            <div className="input-box">
              <span className="icon"><ion-icon name="lock-closed"></ion-icon></span>
              <input type="password" required onChange={(e) => setPassword(e.target.value)} />
              <label>Password</label>
            </div>
            <div className="remember-forgot">
              <label><input type="checkbox" /> Remember me</label>
              <a href="#">Forgot password</a>
            </div>
            <button type="submit" className="btn">Login</button>

            <button type="button" className="btn google-btn" 
                    onClick={handleGoogleLogin}
                    style={{ 
                      display: 'flex', alignItems: 'center', justifyContent: 'center', 
                      background: '#fff', color: '#333', marginTop: '15px', border: '1px solid #ccc' 
                    }}>
              <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
                   alt="G" style={{ width: '18px', marginRight: '10px' }} />
              Login with Google
            </button>

            <div className="login-register">
              <p>Don't have an account? <a href="#" className="register-link" onClick={() => setIsActive(true)}>Register</a></p>
            </div>
          </form>
        </div>
    );
  }